"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFixedGoalDuration = void 0;
const types_1 = require("@fluent-forever/types");
const { CompleteOnboardingTutorial, CompleteReviewSession, CreateSimpleWordFlashcard, CreateSimpleWordOrGrammarFlashcard, SetStudyReminderTime, } = types_1.DailyGoalType;
/**
 * static duration assigned to certain amount of Word flashcard creation
 * More details in Work item: https://fluentforever.visualstudio.com/Fluent%20Forever/_workitems/edit/1946
 */
const getSimpleWordFlashcardDuration = (totalAmount) => {
    switch (totalAmount) {
        case 4:
            return 1;
        case 6:
            return 2;
        case 20:
            return 6;
        default:
            throw new Error("Unknown Simple word Flashcard creation Daily goal amount");
    }
};
/**
 * static duration assigned to certain amount of grammar flashcard creation
 * More details in Work item: https://fluentforever.visualstudio.com/Fluent%20Forever/_workitems/edit/1946
 */
const getSimpleWordOrGrammarFlashcardDuration = (totalAmount) => Math.max(Math.round((totalAmount * 7) / 20), 1);
/**
 * static duration assigned to each type of daily goals
 * More details in Work item: https://fluentforever.visualstudio.com/Fluent%20Forever/_workitems/edit/1946
 */
const getFixedGoalDuration = (type, totalAmount) => {
    switch (type) {
        case CompleteOnboardingTutorial:
        case SetStudyReminderTime:
            return 1 * totalAmount;
        case CompleteReviewSession:
            return 7 * totalAmount;
        case CreateSimpleWordOrGrammarFlashcard:
            return getSimpleWordOrGrammarFlashcardDuration(totalAmount);
        case CreateSimpleWordFlashcard:
            return getSimpleWordFlashcardDuration(totalAmount);
        default:
            throw new Error(`Unknown Daily goal type: ${type}`);
    }
};
exports.getFixedGoalDuration = getFixedGoalDuration;
//# sourceMappingURL=dailyGoals.js.map